export default "__VITE_ASSET__fcq6BbaA__"